import { is2xxStatus } from './AlertMessageLogic'

export default function messageOnRedefinePassword(status) {
    let message

    if (is2xxStatus(status)) status = '2xx'

    switch (status) {
        case 503:
            message = 'Ops! Ocorreu um problema com a internet e não conseguimos redefinir a senha.'
            break
        case 'invalid':
            message = 'Para continuar precisamos que a senha e a confirmação da senha sejam iguais.'
            break
        case '2xx':
            message = 'Atualizamos a senha.'
            break
        case 401:
            message = 'Ops! O seu tempo de acesso expirou, para redefinir a sua senha é necessário realizar o login.'
            break
        case 403:
            message = 'Permissão Negada.'
            break
        case 500:
        default:
            message = 'Ops! Algo estranho ocorreu e não atualizamos a sua senha. Por favor, tente novamente mais tarde.'
    }
    return message
}
